import { createAction, props } from '@ngrx/store';
import { CompaniesFilter } from '../interfaces/companies-filter.interface';

export const setCompaniesFilter = createAction('[Companies UI] Set Companies Filter', props<{ filter: CompaniesFilter }>());

export const clearCompaniesFilter = createAction('[Companies UI] Clear Companies Filter');
